export class Network {
  id: number;
  name: string;
  icon: string;
  color: string;

  chainId: string;
  rpcUrls: string[];
  chainName: string;
  nativeCurrency: {
      name: string,
      symbol: string,
      decimals: number
  };
  blockExplorerUrls: string[];

  disabled: boolean;

  apiUrl: {
    local: string;
    dev: string;
    prod: string;
  }

  constructor(network: Partial<Network>) {
    this.id = network.id;
    this.name = network.name;
    this.icon = network.icon;
    this.color = network.color;

    this.chainId = network.chainId;
    this.rpcUrls = network.rpcUrls;
    this.chainName = network.chainName;
    this.nativeCurrency = network.nativeCurrency;
    this.blockExplorerUrls = network.blockExplorerUrls;

    this.apiUrl = network.apiUrl;

    this.disabled = network.disabled;
  }

  capitalizedName() {
    return this.name.split(' ').map(e => e.charAt(0).toUpperCase() + e.slice(1)).join(' ');
  }

}

export const networkInventory = {
  alphaDuneTestnet: new Network({
    id: 4126084,
    name: 'alpha dune testnet',
    color: '#f0a500',

    chainId: "0x3EF584",
    rpcUrls: ["https://rpc.testnet.alphadune.com"],
    chainName: "Alpha Dune Testnet",
    nativeCurrency: {
        name: "DUNE",
        symbol: "DUNE",
        decimals: 18
    },
    blockExplorerUrls: ["https://explorer.testnet.alphadune.com"],

    apiUrl: {
      local: 'http://localhost:3000',
      dev: 'https://api.houndrace.com',
      prod: 'https://api.houndrace.com'
    }
  })
};

export function networkFactory(chain_id: number): Network {
  switch(Math.abs(chain_id)) {
    case 4126084:
      return networkInventory.alphaDuneTestnet;
    default:
      return new Network({
        id: 0,
        name: 'unsupported network',
        color: 'grey'
      });
  }
}
